<template>
    <div class="container-fluid">
      <div class="row">
        <div class="col bg-light border py-2">
            <table id="myLabAppvTable" class="table table-sm table-hover table-striped table-bordered" style="width: 100%;">
                <thead class="text-white" style="background:Navy">
                <tr>
                    <th title="รับชำระเงิน">Paid</th>
                    <th>สถานะ</th>
                    <th>ชื่อสาขา</th>
                    <th>เลขที่ใบตรวจ</th>
                    <th>วันที่</th>
                    <th>ชื่อ-สกุล คนไข้</th>
                    <th>เพศ</th>
                    <th>อายุ(ปี)</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in datalists" :key="item.ROID" @click="viewResultRO(item)"
                  v-bind:data-id="item.ROID">
                    <td class="">{{ arrPaid[item.Paid] }}</td>
                    <td class="">
                      <button id="btnGroupDrop1" type="button"
                          class="btn btn-outline btn-sm dropdown-toggle p-0" data-bs-toggle="dropdown" aria-expanded="false">
                          {{ arrDocStatus[item.Status] }}
                      </button>
                      <ul class="dropdown-menu pe-3" aria-labelledby="btnGroupDrop1">
                        <li class="mx-2 text-danger dropdown-item" @click="StatusPreviousStep(item)" v-if="item.Status>0" title="ถอยสถานะกลับไปก่อนหน้า"> ถอยสถานะกลับไปก่อนหน้า </li>
                      </ul>
                    </td>
                    <td class="text-start">{{ item.BranchName }}</td>
                    <td class="text-start" :title=' "สิ่งส่งตรวจ : "+item.Specimen'>{{ item.RONo }}</td>
                    <td class="text-start">{{ item.DocDate }}</td>
                    <td class="text-start">{{ item.PatName }} {{ item.PatLName}}</td>
                    <td class="">{{ arrSex[item.Sex] }}</td>
                    <td class="text-center">{{ item.AgeYears }}.{{ item.AgeMonths }}</td>
                </tr>
                </tbody>
            </table>
        </div>
      </div>
      <div id="divToPrint" hidden>
        <table style="width:100%" data-pdfmake="{&quot;layout&quot;:&quot;lightHorizontalLines&quot;}">
          <thead>
            <tr>
              <th>Test</th>
              <th></th>
              <th>Result</th>
              <th>Unit</th>
              <th>Method</th>
              <th>Specimen</th>
              <th>Normal Range</th>
            </tr>
          </thead>
          <tr v-for="item in reportDtl" :key="item.ROID">
            <td style="width:150px;">{{item.ItemTestName}}</td>
            <td style="width:10px;" > {{arrRepeatChk[item.RepeatChecked]}} </td>
            <td style="width:180px;" v-if="(item.ValueType==1)">{{item.PrefixResult}} {{item.ResultText}}</td>
            <td style="width:180px;" v-else>{{item.PrefixResult}} {{item.Result}}</td>
            <td style="width:30px;" > {{item.Unit}} </td>
            <td style="width:60px;" >{{item.Method}}  </td>
            <td style="width:80px;" > {{item.Specimen}}</td>
            <td style="width:80px;" >{{item.NormalRange}}</td>
          </tr>
        </table>
        <br>
      </div>
    </div>
</template>

<script>
// import axios from 'axios'
// import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    var globalCorpInfo = inject('corpInfo', {})
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition, globalCorpInfo
    }
  },
  name: 'LabApprove1View',
  data () {
    return {
      arrRepeatChk: ['', 'R'],
      arrSex: ['', 'Male', 'Female'],
      arrDocStatus: ['New', 'Lab', 'Resulted', 'AP'],
      arrPayType: ['เงินสด', 'เครดิต'],
      arrPaid: ['', 'Paid'],

      dataheader: null
    }
  },
  props: ['datalists'],
  mounted () {

  },
  components: {

  },
  methods: {
    StatusPreviousStep (row) {
      var stepBack = 1
      if (this.globalCorpInfo.StatusStep === '1' && row.Status === '2') {
        // 0-New - 2-Result 3-AP : ถอยสถานะจาก 2-Result ข้ามสถานะ 2-Lab เป็น 0-New
        stepBack = 2
      }
      var self = this
      Swal.fire({
        title: this.arrDocStatus[row.Status] + ' &#8594; ' + this.arrDocStatus[row.Status - stepBack] +
              '<br>คุณต้องการถอยสถานะกลับไป<br>"สถานะก่อนหน้า"<br>ใช่หรือไม่?',
        text: row.RONo + '\n' + row.PatName + ' ' + row.PatLName,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ใช่! แน่ใจ',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            type: 'POST',
            url: this.http_baseurl + 'setdata/update_ro_status_previous.php',
            data: { ROID: row.ROID, UserID: self.globalUserID, StatusPrevious: row.Status - stepBack }
          }).done(function () {
            Swal.fire({
              text: 'ถอยสถานะเสร็จเรียบร้อย',
              icon: 'success',
              showConfirmButton: false,
              timer: 1500
            }).then((result) => {
              self.backPageAfterSave()
            })
          })
        }
      })
    },
    isDetected (str1, srcStr) {
      if (str1.toLowerCase().indexOf(srcStr) === -1) {
        // Detected
        return true
      } else {
        return false
      }
    },
    viewResultRO (row) {
      console.log(row)
      this.$emit('onViewResultEvent', row)
    },
    backPageAfterSave () {
      this.$emit('onBackPageAfterSaveEvent')
    }
  }
}
</script>
